"use strict";
/**
 * Injection identifiers
 */
exports.__esModule = true;
var IDENTIFIERS = {
    AntiFraud: Symbol["for"]("AntiFraud"),
    CardAsyncService: Symbol["for"]("CardAsyncService"),
    CardService: Symbol["for"]("CardService"),
    CashService: Symbol["for"]("CashService"),
    CommissionService: Symbol["for"]("CommissionService"),
    KushkiGateway: Symbol["for"]("KushkiGateway"),
    KushkiService: Symbol["for"]("KushkiService"),
    MobileProcessorService: Symbol["for"]("MobileProcessorService"),
    MultiMerchantService: Symbol["for"]("MultiMerchantService"),
    PayoutsCashService: Symbol["for"]("PayoutsCashService"),
    PayoutsTransferService: Symbol["for"]("PayoutsTransferService"),
    SecureService: Symbol["for"]("SecureService"),
    TransferService: Symbol["for"]("TransferService"),
    TransferSubscriptionService: Symbol["for"]("TransferSubscriptionsService")
};
exports.IDENTIFIERS = IDENTIFIERS;
